/**
 * Allows to use console log based on debug flat that is set in configuration
 */

import config from 'config';

const debug = config.get('debug');

export function consoleLog(...args) {
  if (debug) {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
}

export function consoleError(...args) {
  // eslint-disable-next-line no-console
  console.error(...args);
}

export function consoleWarn(...args) {
  if (debug) {
    // eslint-disable-next-line no-console
    console.warn(...args);
  }
}
